import { useSelector } from 'react-redux';

import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { NEXT_PAYMENTS_PERIOD } from '../../constants';
import type { FlexBuyPaymentFigureField } from '../types';
import { replaceConstantWithTerm } from '../utils';

export const useNextPaymentPeriodField = (): FlexBuyPaymentFigureField => {
    const flexBuyPayment = useSelector(offerReduxSelectors.getCurrentFlexBuyPayments);

    const nextPaymentPeriodValue = flexBuyPayment?.secondTermPaymentDetail?.paymentAmount || 0;
    const nextTerm = flexBuyPayment?.secondTermPaymentDetail?.term;

    return {
        label: replaceConstantWithTerm({ constantLabel: NEXT_PAYMENTS_PERIOD, currentTerm: `${nextTerm || ''}` }),
        value: formatDollarsAndCents(nextPaymentPeriodValue)
    };
};
